const NAV_LINKS = [
  { href: "#services", label: "Supports & Services" },
  { href: "#why-us", label: "About Us" },
  { href: "#how-it-works", label: "How It Works" },
  { href: "#audiences", label: "Who We Support" },
  { href: "#service-area", label: "South Australia" },
  { href: "#reviews", label: "Testimonials" },
  { href: "#faq", label: "FAQ" },
];

export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-[#FAF8F5]/90 backdrop-blur-md border-b border-[#E8E2D8]" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between gap-4">
        <a href="#hero" data-testid="header-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Beneficence Care logo" className="h-10 w-10 rounded-full shadow-sm shrink-0" />
          <span className="text-lg sm:text-xl font-display font-semibold tracking-tight text-[#1E282D] whitespace-nowrap">
            Beneficence Care
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-5 text-[13px] font-medium text-[#4D5A60]" data-testid="header-nav">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} data-testid={`nav-${link.href.slice(1)}`} className="hover:text-[#1E282D] transition-colors">
              {link.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="#contact" data-testid="header-enquiry-button" className="hidden sm:inline-flex px-4 py-2 text-sm font-medium text-[#323E44] bg-[#EFE7DC] hover:bg-[#E4D9CC] rounded-full transition-colors">
            Send Enquiry
          </a>
          <a href="#contact" data-testid="header-book-button" className="px-4 py-2 text-sm font-medium text-[#FAF8F5] bg-[#2E3C42] hover:bg-[#1E282D] rounded-full transition-colors shadow-sm">
            Book Time
          </a>
        </div>
      </div>
    </header>
  );
}
